import { render, staticRenderFns } from "./WidgetBulkPendingApproval.vue?vue&type=template&id=ee00d12c"
import script from "./WidgetBulkPendingApproval.vue?vue&type=script&lang=js"
export * from "./WidgetBulkPendingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports